import profileReducer from '@app/store/slices/profile-slice'
import usersReducer from '@app/store/slices/users-slice'
import authReducer from '@app/store/slices/auth-slice'
import pwaReducer from '@app/store/slices/pwa-slice'
import deviceReducer from '@app/store/slices/device-slice'
import firmsReducer from '@app/store/slices/firms-slice'
import templatesReducer from '@app/store/slices/templates-slice'
import errorsReducer from '@app/store/slices/error-slice'
import inverterSlice from '@app/store/slices/inverter-slice'
import alarmSlice from '@app/store/slices/alarm-slice'
import partsReducer from '@app/store/slices/parts-slice'
import userConsentsReducer from '@app/store/slices/userConsent-slice'
import rodoPoliciesDocumentsReducer from '@app/store/slices/rodoPoliciesDocuments-slice'
import dataProcessingConsentsReducer from '@app/store/slices/dataProcessingConsents-slice'
import notificationReducer from '@app/store/slices/notification-slice'

export default {
  profile: profileReducer,
  users: usersReducer,
  device: deviceReducer,
  auth: authReducer,
  pwa: pwaReducer,
  firms: firmsReducer,
  templates: templatesReducer,
  errorsTemplate: errorsReducer,
  inverter: inverterSlice,
  alarm: alarmSlice,
  parts: partsReducer,
  userConsents: userConsentsReducer,
  rodoPoliciesDocuments: rodoPoliciesDocumentsReducer,
  dataProcessingConsents: dataProcessingConsentsReducer,
  notification: notificationReducer,
}
